module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Users","button":"Add a user"}}')
  delete Component.options._Ctor
}
